import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Table } from '../../components/ui/Table';
import { Download, History } from 'lucide-react';
interface StockReportProps {
  onAuditClick: () => void;
}
export function StockReport({
  onAuditClick
}: StockReportProps) {
  return <div className="space-y-6" data-id="element-754">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-755">
        <div data-id="element-756">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-757">
            Laporan Posisi Stok
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-758">
            Rekapitulasi stok nasional per komoditas
          </p>
        </div>
        <div className="flex flex-wrap gap-2 w-full sm:w-auto" data-id="element-759">
          <Button variant="outline" onClick={onAuditClick} icon={<History size={18} data-id="element-761" />} className="flex-1 sm:flex-none" data-id="element-760">
            Audit Trail
          </Button>
          <Button icon={<Download size={18} data-id="element-763" />} className="flex-1 sm:flex-none" data-id="element-762">
            Export PDF
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6" data-id="element-764">
        <Card title="Total Beras" className="border-l-4 border-l-bulog-blue" data-id="element-765">
          <div className="text-3xl lg:text-4xl font-bold text-bulog-blue" data-id="element-766">
            1.25 Juta{' '}
            <span className="text-sm text-gray-500 font-normal" data-id="element-767">Ton</span>
          </div>
        </Card>
        <Card title="Total Jagung" className="border-l-4 border-l-yellow-500" data-id="element-768">
          <div className="text-3xl lg:text-4xl font-bold text-yellow-600" data-id="element-769">
            250 Ribu{' '}
            <span className="text-sm text-gray-500 font-normal" data-id="element-770">Ton</span>
          </div>
        </Card>
        <Card title="Total Kedelai" className="border-l-4 border-l-green-500" data-id="element-771">
          <div className="text-3xl lg:text-4xl font-bold text-green-600" data-id="element-772">
            80 Ribu{' '}
            <span className="text-sm text-gray-500 font-normal" data-id="element-773">Ton</span>
          </div>
        </Card>
      </div>

      <Card title="Detail Per Divre (Divisi Regional)" data-id="element-774">
        <Table columns={[{
        header: 'Divre / Wilayah',
        accessor: (item: any) => <span className="font-semibold text-gray-900" data-id="element-776">
                  {item.region}
                </span>
      }, {
        header: 'Beras (Ton)',
        accessor: 'rice',
        className: 'hidden sm:table-cell'
      }, {
        header: 'Jagung (Ton)',
        accessor: 'corn',
        className: 'hidden md:table-cell'
      }, {
        header: 'Gula (Ton)',
        accessor: 'sugar',
        className: 'hidden lg:table-cell'
      }, {
        header: 'Total (Ton)',
        accessor: (item: any) => <span className="font-bold text-bulog-blue" data-id="element-777">{item.total}</span>
      }]} data={[{
        region: 'DKI Jakarta & Banten',
        rice: '150,000',
        corn: '20,000',
        sugar: '5,000',
        total: '175,000'
      }, {
        region: 'Jawa Barat',
        rice: '300,000',
        corn: '50,000',
        sugar: '10,000',
        total: '360,000'
      }, {
        region: 'Jawa Timur',
        rice: '350,000',
        corn: '80,000',
        sugar: '15,000',
        total: '445,000'
      }, {
        region: 'Sulawesi Selatan',
        rice: '200,000',
        corn: '40,000',
        sugar: '8,000',
        total: '248,000'
      }]} keyExtractor={i => i.region} data-id="element-775" />
      </Card>
    </div>;
}